import React, { FC, useMemo } from 'react'
import styles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getStoreRef } from 'reducks/auth/selectors'
import { FlexRow } from 'components/Flex'
import { BlueTag } from 'components/Tag'
import { openStoreSwitchModal } from 'reducks/modal/operations'
import { SwitchingStoreRefType } from 'types/auth'
import { useSwitchStoreName } from 'hooks/auth'
import { FirebaseDocRefType } from 'firebase/index'

type Props = {
  switchingStoreRef: SwitchingStoreRefType
}

const StoreSwitchCard: FC<Props> = React.memo((props) => {
  const { switchingStoreRef } = props
  const dispatch = useDispatch()
  const currentStoreRef: FirebaseDocRefType | undefined = useSelector((state: State) => getStoreRef(state))
  const storeName = useSwitchStoreName(switchingStoreRef)

  const label = useMemo(() => {
    if (currentStoreRef?.id === switchingStoreRef.store_ref.id) {
      return <BlueTag shape={'ellipse'} size={'large'} tagName={'操作中'} />
    } else {
      return (
        <a
          className={`${text.color_blue_main} ${text.font_xxsmall}`}
          role={'button'}
          onClick={() =>
            dispatch(
              openStoreSwitchModal(
                storeName,
                switchingStoreRef.store_ref,
                switchingStoreRef.manufacturer_ref,
                undefined
              )
            )
          }
        >
          切り替える
        </a>
      )
    }
  }, [switchingStoreRef, currentStoreRef, storeName])

  return (
    <div className={styles.row__inner}>
      <FlexRow justifyContent={'between'}>
        <span className={styles.row__inner__label}>{storeName}</span>
        {label}
      </FlexRow>
    </div>
  )
})

export default StoreSwitchCard
